<template>
  <Menu  class="nav-menu" theme="dark" accordion>
    <a href="/" class="top-header-logo">
      <!-- <img src="@/assets/images/logo.png"> -->
    </a>
    <Submenu :name="index" v-for="(item, index) in navMenu" :key="index">
        <template slot="title">
            <Icon :type="item.icon" :size="20" />
            {{item.name}}
        </template>
        <MenuItem @click.native="navRouter(itemChild.url)" :name="index+'-'+indexClikd" v-for="(itemChild, indexClikd) in item.list"  :key="indexClikd">{{itemChild.name}}</MenuItem>
    </Submenu>
  </Menu>
</template>

<script>
export default {
  data () {
    return {
      navMenu: {},
      openeds: []
    }
  },
  mounted () {
    this.iniNav()
    this.iniPower()
  },
  methods: {
    iniNav () {
      this.$axios.get('/sys/menu/nav')
      .then(function (response) {
        if (response.data && response.data.success) {
          this.navMenu = response.data.data.menuList
        } else {
        }
      }.bind(this))
    },
    iniPower () {
      this.$axios.get('sys/menu/navPermission')
        .then(function (response) {
          if (response.data.success) {
            localStorage.setItem('menuAuthority', response.data.data)
          } else {
            this.$Message.error(response.data.errMsg)
          }
        }.bind(this))
    },
    navRouter (url) {
      this.$emit('on-select', url)
    },
    updateOpenName () {

    }
  }
}
</script>

<style lang="scss" scoped>
  .nav-menu {
    position: fixed;
    width: 240px;
    top: 0;
    bottom: 0;
    z-index: 99;
    background: #001529;
    .top-header-logo {
      display: block;
      margin: 10px auto 10px auto;
      text-align: center;
      img {
        width: 162px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/NavMenu.vue